import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListIcon from "@mui/icons-material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import ListItemButton from "@mui/material/ListItemButton";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import "./layout.css";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import routeConstant from "../../../route/compoent/routeConstant";
import { StoreContext } from "../../../store/Provider";
import Menu from "@material-ui/core/Menu";
import { withStyles } from "@material-ui/core/styles";
import {
  IsLogin,
  IsShowOutstanding,
  IsShowOrder,
  IsShowShipment,
  IsShowRMS,
  IsShowCreateOrder,
  IsShowOrderList,
  IsShowShipmentList,
  IsShowShipmentAnalytics,
  IsShowShipmentDashboard,
  IsShowOrderDashboard,
  IsShowOrderLog,
  IsShowOrderReport,
  IsShowRMSLCL,
  IsShowRMSFCL,
  IsShowFinance,
  IsShowShipmentReport,
  IsShowCargoInsurance,
  IsShowScheduleSearch,
  IsAminSettingNew,
} from "../../../../src/utils";
import Header from "../../../order_managment/common/component/header/Header";
import Blogsw from "../../screens/SVG/blogsw";
import Mymts from "../../screens/SVG/mymts";
import Schedule from "../../screens/SVG/schedule";
import Statement from "../../screens/SVG/statement";
import Shipment from "../../screens/SVG/Shipment";
import Order from "../../screens/SVG/order";
import Analytics from "../../screens/SVG/analytics";
import Dashboard from "../../screens/SVG/dashboard";
import Createorder from "../../screens/SVG/createorder";
import Systemlog from "../../screens/SVG/systemlog";

import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { StoreContext as OmsStore } from "../../../order_managment/store";
import { basename } from "../../../config";
import SettingsIcon from "@mui/icons-material/Settings";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Notification from "../../../order_managment/screens/notification/Notification";
import MergeOrder from "../../../order_managment/screens/mergeOrder/MergeOrder";
import ViewSubOrder from "../../../order_managment/screens/mergeOrder/component/ViewSubOrder";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { IconButton } from "@mui/material";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
const drawerWidth = 12.5;

const openedMixin = (theme) => ({
  width: `${drawerWidth}rem`,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(3rem + 1px)`,
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: `${drawerWidth}rem`,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MainLayout() {
  const theme = useTheme();
  const context = React.useContext(StoreContext);
  const omscontext = React.useContext(OmsStore);
  const location = useLocation();
  const [showShipmentMenuListItem, setShowShipmentMenuListItem] =
    React.useState(false);
  const [showAdminListItem, setShowAdminListItem] = React.useState(false);
  const [showAdmin, setShowAdmin] = React.useState(false);
  const [ShowRmsListItem, setShowRmsListItem] = React.useState(false);
  const [showLCL, setShowLCL] = React.useState(false);
  const [showFCL, setShowFCL] = React.useState(false);
  const [showOrderMenuListItem, setShowOrderMenuListItem] =
    React.useState(false);

  React.useEffect(() => {
    if (location.pathname.includes("shipments")) {
      setShowShipmentMenuListItem(true);
    } else if (location.pathname.includes("order")) {
      setShowOrderMenuListItem(true);
    }
  }, []);

  const handleClick = (type) => {
    if (type === "shipment") {
      setShowShipmentMenuListItem((prev) => !prev);
    }
    if (type === "order") {
      setShowOrderMenuListItem((prev) => !prev);
    }
    if (type === "admin") {
      setShowAdminListItem((prev) => !prev);
    }
    if (type === "rms") {
      setShowRmsListItem((prev) => !prev);
    }
    if (type === "lcl") {
      setShowLCL((prev) => !prev);
    }
    if (type === "fcl") {
      setShowFCL((prev) => !prev);
    }
    if (type === "new") {
      setShowFCL((prev) => !prev);
    }
  };

  const SidebarMenuItem = ({
    to,
    selected,
    icon,
    primary,
    menuInnerItem = false,
  }) => {
    return (
      <Link to={to}>
        <ListItemButton
          className={
            menuInnerItem && context.sidebarOpen
              ? "linkItemButton menuInnerItem"
              : "linkItemButton"
          }
          selected={selected}
        >
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={primary} />
        </ListItemButton>
      </Link>
    );
  };

  const ShipmentPermisionCollection = {
    ShipmentDashBoard: true,
  };

  return (
    <div className="mainscreen">
      <Drawer
        className="mtsSidebar"
        variant="permanent"
        open={context.sidebarOpen}
      >
        <DrawerHeader className="sidebarHeader">
          {!context.sidebarOpen ? (
            <div className="_sidebarHeaderMini">
              <img
                className="_sidebarLogoMini"
                src={`/${basename}/Assets/Images/SidebarLogoMini.png`}
                alt="Sidebar Logo"
              />
            </div>
          ) : (
            <div className="_sidebarHeader">
              <img
                className="_sidebarLogo"
                src={`/${basename}/Assets/Images/SidebarLogo.png`}
                alt="Sidebar Logo"
              />
            </div>
          )}
        </DrawerHeader>
        <List>
          <SidebarMenuItem
            to={routeConstant.BLOGS}
            selected={
              location.pathname.includes(routeConstant.BLOGS) ? true : false
            }
            icon={
              <Blogsw
                colorCode={
                  location.pathname.includes(routeConstant.BLOGS)
                    ? "#002e76"
                    : "#ccd2e2"
                }
              />
            }
            primary="Blogs"
          />
          {!IsLogin() && (
            <SidebarMenuItem
              to={routeConstant.LOGIN}
              selected={
                location.pathname.includes(routeConstant.LOGIN) ? true : false
              }
              icon={
                <Mymts
                  colorCode={
                    location.pathname.includes(routeConstant.LOGIN)
                      ? "#002e76"
                      : "#ccd2e2"
                  }
                />
              }
              primary="MY MTS"
            />
          )}
          {IsShowScheduleSearch() && (
            <SidebarMenuItem
              to={
                IsLogin()
                  ? routeConstant.SCHEDULE
                  : routeConstant.SCHEDULE_LOGIN
              }
              selected={
                location.pathname.includes(routeConstant.SCHEDULE)
                  ? true
                  : false
              }
              icon={
                <Schedule
                  colorCode={
                    location.pathname.includes(routeConstant.SCHEDULE)
                      ? "#002e76"
                      : "#ccd2e2"
                  }
                />
              }
              primary="Schedule"
            />
          )}
          {IsShowCargoInsurance() && (
            <SidebarMenuItem
              to={routeConstant.INSURANCE}
              selected={
                location.pathname.includes(routeConstant.INSURANCE)
                  ? true
                  : false
              }
              icon={
                <BookmarkBorderIcon
                  colorCode={
                    location.pathname.includes(routeConstant.INSURANCE)
                      ? "#002e76"
                      : "#ccd2e2"
                  }
                />
              }
              primary="Cargo Insurance"
            />
          )}
          {/* ---------------- */}
          {!IsLogin() && (
            <SidebarMenuItem
              to={routeConstant.RMS_LOGIN}
              selected={
                location.pathname.includes(routeConstant.RMS_LOGIN)
                  ? true
                  : false
              }
              icon={
                <MoveToInboxIcon
                  colorCode={
                    location.pathname.includes(routeConstant.RMS_LOGIN)
                      ? "#002e76"
                      : "#ccd2e2"
                  }
                />
              }
              primary="RMS"
            />
          )}

          {IsLogin() && (
            <>
              {IsShowFinance() && (
                <SidebarMenuItem
                  to={routeConstant.STATEMENT}
                  selected={
                    location.pathname.includes(routeConstant.STATEMENT)
                      ? true
                      : false
                  }
                  icon={
                    <Statement
                      colorCode={
                        location.pathname.includes(routeConstant.STATEMENT)
                          ? "#002e76"
                          : "#ccd2e2"
                      }
                    />
                  }
                  primary="Statement of Account"
                />
              )}
              {IsShowShipment() && (
                <>
                  <ListItemButton
                    className="linkItemButton"
                    onClick={() => handleClick("shipment")}
                  >
                    <ListItemIcon>
                      <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Shipments" />
                    {showShipmentMenuListItem ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse
                    in={showShipmentMenuListItem}
                    timeout="auto"
                    unmountOnExit
                  >
                    {IsShowShipmentDashboard() && (
                      <SidebarMenuItem
                        to={routeConstant.SHIPMENT}
                        menuInnerItem={true}
                        selected={
                          location.pathname.includes(routeConstant.SHIPMENT)
                            ? true
                            : false
                        }
                        icon={
                          <Shipment
                            colorCode={
                              location.pathname.includes(routeConstant.SHIPMENT)
                                ? "#002e76"
                                : "#ccd2e2"
                            }
                          />
                        }
                        primary="Shipment Listing"
                      />
                    )}

                    {IsShowShipmentAnalytics() && (
                      <SidebarMenuItem
                        to={routeConstant.DASHBOARD}
                        menuInnerItem={true}
                        selected={
                          location.pathname.includes(routeConstant.DASHBOARD)
                            ? true
                            : false
                        }
                        icon={
                          <Analytics
                            colorCode={
                              location.pathname.includes(
                                routeConstant.DASHBOARD
                              )
                                ? "#002e76"
                                : "#ccd2e2"
                            }
                          />
                        }
                        primary="Analytics"
                      />
                    )}
                    {IsShowShipmentReport() && (
                      <SidebarMenuItem
                        to={routeConstant.SHIPMENT_REPORT}
                        menuInnerItem={true}
                        selected={
                          location.pathname.includes(
                            routeConstant.SHIPMENT_REPORT
                          )
                            ? true
                            : false
                        }
                        icon={
                          <AssessmentOutlinedIcon
                            colorCode={
                              location.pathname.includes(
                                routeConstant.SHIPMENT_REPORT
                              )
                                ? "#002e76"
                                : "#ccd2e2"
                            }
                          />
                        }
                        primary="Shipment Report"
                      />
                    )}

                  {/* Co2 Report */}
                  {IsShowShipmentReport() && (
                      <SidebarMenuItem
                        to={routeConstant.SHIPMENTCO2_REPORT}
                        menuInnerItem={true}
                        selected={
                          location.pathname.includes(
                            routeConstant.SHIPMENTCO2_REPORT
                          )
                            ? true
                            : false
                        }
                        icon={
                          <AssessmentOutlinedIcon
                            colorCode={
                              location.pathname.includes(
                                routeConstant.SHIPMENTCO2_REPORT
                              )
                                ? "#002e76"
                                : "#ccd2e2"
                            }
                          />
                        }
                        primary="Co2 Reporting"
                      />
                    )}
                  </Collapse>
                </>
              )}
              {IsShowOrder() && (
                <>
                  <ListItemButton
                    className="linkItemButton"
                    onClick={() => handleClick("order")}
                  >
                    <ListItemIcon>
                      <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Order" />
                    {showOrderMenuListItem ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse
                    in={showOrderMenuListItem}
                    timeout="auto"
                    unmountOnExit
                  >
                    {IsShowOrderDashboard() && (
                      <SidebarMenuItem
                        to={routeConstant.ORDER_DASHBOARD}
                        menuInnerItem={true}
                        selected={
                          location.pathname.includes(
                            routeConstant.ORDER_DASHBOARD
                          )
                            ? true
                            : false
                        }
                        icon={
                          <Dashboard
                            colorCode={
                              location.pathname.includes(
                                routeConstant.ORDER_DASHBOARD
                              )
                                ? "#002e76"
                                : "#ccd2e2"
                            }
                          />
                        }
                        primary="Dashboard"
                      />
                    )}
                    {IsShowOrderList() ? (
                      <SidebarMenuItem
                        to={routeConstant.ORDER_LIST_PLACED}
                        menuInnerItem={true}
                        selected={
                          location.pathname.includes(routeConstant.ORDER_LIST)
                            ? true
                            : false
                        }
                        icon={
                          <Order
                            colorCode={
                              location.pathname.includes(
                                routeConstant.ORDER_LIST
                              )
                                ? "#002e76"
                                : "#ccd2e2"
                            }
                          />
                        }
                        primary="Order List"
                      />
                    ) : null}
                    {IsShowCreateOrder() ? (
                      <SidebarMenuItem
                        to={routeConstant.CREATE_ORDER}
                        menuInnerItem={true}
                        selected={
                          location.pathname.includes(
                            routeConstant.CREATE_ORDER_MAIN
                          )
                            ? true
                            : false
                        }
                        icon={
                          <Createorder
                            colorCode={
                              location.pathname.includes(
                                routeConstant.CREATE_ORDER_MAIN
                              )
                                ? "#002e76"
                                : "#ccd2e2"
                            }
                          />
                        }
                        primary="Create New Order"
                      />
                    ) : null}
                    {IsShowOrderLog() && (
                      <SidebarMenuItem
                        to={routeConstant.SYSTEM_LOG}
                        menuInnerItem={true}
                        selected={
                          location.pathname.includes(routeConstant.SYSTEM_LOG)
                            ? true
                            : false
                        }
                        icon={
                          <Systemlog
                            colorCode={
                              location.pathname.includes(
                                routeConstant.SYSTEM_LOG
                              )
                                ? "#002e76"
                                : "#ccd2e2"
                            }
                          />
                        }
                        primary="System Log"
                      />
                    )}
                    {IsShowOrderReport() && (
                      <SidebarMenuItem
                        to={routeConstant.REPORTS}
                        menuInnerItem={true}
                        selected={
                          location.pathname.includes(routeConstant.REPORTS)
                            ? true
                            : false
                        }
                        icon={
                          <AssessmentOutlinedIcon
                            style={{
                              color: location.pathname.includes(
                                routeConstant.REPORTS
                              )
                                ? "#002e76"
                                : "#ccd2e2",
                            }}
                          />
                        }
                        primary={
                          <div className="newComingSoonBadge ">Reports</div>
                        }
                      />
                    )}
                    {/* <SidebarMenuItem
                      to={routeConstant.NOTIFICATION}
                      menuInnerItem={true}
                      selected={
                        location.pathname.includes(routeConstant.NOTIFICATION)
                          ? true
                          : false
                      }
                      icon={
                        <NotificationsNoneOutlinedIcon
                          style={{
                            color: location.pathname.includes(
                              routeConstant.NOTIFICATION
                            )
                              ? "#002e76"
                              : "#ccd2e2",
                          }}
                        />
                      }
                      primary={"Notification"}
                    /> */}
                  </Collapse>
                </>
              )}
              {context.omsUserData?.UserRoles.includes("Admin") && (
                <>
                  <ListItemButton
                    className="linkItemButton"
                    onClick={() => handleClick("admin")}
                  >
                    <ListItemIcon>
                      <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Admin Settings" />
                    {showAdminListItem ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={showAdminListItem} timeout="auto" unmountOnExit>
                    <SidebarMenuItem
                      to={routeConstant.USERS}
                      menuInnerItem={true}
                      selected={
                        location.pathname.includes(routeConstant.USERS)
                          ? true
                          : false
                      }
                      icon={
                        <SettingsIcon
                          style={{
                            color: location.pathname.includes(
                              routeConstant.USERS
                            )
                              ? "#002e76"
                              : "#ccd2e2",
                          }}
                        />
                      }
                      primary="Users List"
                    />
                    <SidebarMenuItem
                      to={routeConstant.CREATE_USER}
                      menuInnerItem={true}
                      selected={
                        location.pathname.includes(routeConstant.CREATE_USER)
                          ? true
                          : false
                      }
                      icon={
                        <NoteAddIcon
                          style={{
                            color: location.pathname.includes(
                              routeConstant.CREATE_USER
                            )
                              ? "#002e76"
                              : "#ccd2e2",
                          }}
                        />
                      }
                      primary="Create User"
                    />
                  </Collapse>
                </>
              )}
              {IsAminSettingNew() && (
                <>
                  <ListItemButton
                    className="linkItemButton"
                    onClick={() => setShowAdmin(!showAdmin)}
                  >
                    <ListItemIcon>
                      <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Admin Settings New" />
                    {showAdmin ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={showAdmin} timeout="auto" unmountOnExit>
                    <SidebarMenuItem
                      to={routeConstant.CREATE_NEW}
                      menuInnerItem={true}
                      selected={
                        location.pathname.includes(routeConstant.CREATE_NEW)
                          ? true
                          : false
                      }
                      icon={
                        <NoteAddIcon
                          style={{
                            color: location.pathname.includes(
                              routeConstant.CREATE_NEW
                            )
                              ? "#002e76"
                              : "#ccd2e2",
                          }}
                        />
                      }
                      primary="Create User"
                    />
                    <SidebarMenuItem
                      to={routeConstant.PERMISSION}
                      menuInnerItem={true}
                      selected={
                        location.pathname.includes(routeConstant.PERMISSION)
                          ? true
                          : false
                      }
                      icon={
                        <SettingsIcon
                          style={{
                            color: location.pathname.includes(
                              routeConstant.PERMISSION
                            )
                              ? "#002e76"
                              : "#ccd2e2",
                          }}
                        />
                      }
                      primary="Permission List"
                    />
                  </Collapse>
                </>
               )} 

              {/* )} */}
              {IsShowRMS() ? (
                <>
                  <ListItemButton
                    className="linkItemButton"
                    onClick={() => handleClick("rms")}
                  >
                    <ListItemIcon>
                      <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="RMS" />
                    {ShowRmsListItem ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={ShowRmsListItem} timeout="auto" unmountOnExit>
                    {context.omsUserData?.UserRoles.includes("Admin") ? (
                      <>
                        {IsShowRMSLCL() && (
                          <>
                            <ListItemButton
                              className="linkItemButton"
                              onClick={() => handleClick("lcl")}
                            >
                              <ListItemIcon>
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText primary="LCL" />
                              {showLCL ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={showLCL} timeout="auto" unmountOnExit>
                              <SidebarMenuItem
                                to={routeConstant.COST}
                                menuInnerItem={true}
                                selected={
                                  location.pathname.includes(routeConstant.COST)
                                    ? true
                                    : false
                                }
                                icon={
                                  <IconButton
                                    sx={{
                                      border: "3px solid rgb(204, 210, 226)",
                                      borderRadius: "10%",
                                      padding: "2px",
                                    }}
                                  >
                                    <ListIcon
                                      style={{
                                        color: location.pathname.includes(
                                          routeConstant.COST
                                        )
                                          ? "#002e76"
                                          : "#ccd2e2",
                                      }}
                                    />
                                  </IconButton>
                                }
                                primary="Cost"
                              />
                              <SidebarMenuItem
                                to={routeConstant.SELL}
                                menuInnerItem={true}
                                selected={
                                  location.pathname.includes(routeConstant.SELL)
                                    ? true
                                    : false
                                }
                                icon={
                                  <IconButton
                                    sx={{
                                      border: "3px solid rgb(204, 210, 226)",
                                      borderRadius: "10%",
                                      padding: "2px",
                                    }}
                                  >
                                    <ListIcon
                                      style={{
                                        color: location.pathname.includes(
                                          routeConstant.SELL
                                        )
                                          ? "#002e76"
                                          : "#ccd2e2",
                                      }}
                                    />
                                  </IconButton>
                                }
                                primary="Sell"
                              />
                              {context.omsUserData?.UserRoles.includes(
                                "Admin" || "Agent"
                              ) && (
                                <SidebarMenuItem
                                  to={routeConstant.LCL}
                                  menuInnerItem={true}
                                  selected={
                                    location.pathname.includes(
                                      routeConstant.LCL
                                    )
                                      ? true
                                      : false
                                  }
                                  icon={
                                    <IconButton
                                      sx={{
                                        border: "3px solid rgb(204, 210, 226)",
                                        borderRadius: "10%",
                                        padding: "2px",
                                      }}
                                    >
                                      <ListIcon
                                        style={{
                                          color: location.pathname.includes(
                                            routeConstant.LCL
                                          )
                                            ? "#002e76"
                                            : "#ccd2e2",
                                        }}
                                      />
                                    </IconButton>
                                  }
                                  primary="Quote"
                                />
                              )}
                            </Collapse>
                          </>
                        )}
                        {IsShowRMSFCL() && (
                          <>
                            <ListItemButton
                              className="linkItemButton"
                              onClick={() => handleClick("fcl")}
                            >
                              <ListItemIcon>
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText primary="FCL" />
                              {showFCL ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={showFCL} timeout="auto" unmountOnExit>
                              {/* <SidebarMenuItem
                            to={routeConstant.COST}
                            menuInnerItem={true}
                            selected={
                              location.pathname.includes(routeConstant.COST)
                                ? true
                                : false
                            }
                            icon={
                              <IconButton
                                sx={{
                                  border: "3px solid rgb(204, 210, 226)",
                                  borderRadius: "10%",
                                  padding: "2px",
                                }}
                              >
                                <ListIcon
                                  style={{
                                    color: location.pathname.includes(
                                      routeConstant.COST
                                    )
                                      ? "#002e76"
                                      : "#ccd2e2",
                                  }}
                                />
                              </IconButton>
                            }
                            primary="Cost"
                          />
                          <SidebarMenuItem
                            to={routeConstant.SELL}
                            menuInnerItem={true}
                            selected={
                              location.pathname.includes(routeConstant.SELL)
                                ? true
                                : false
                            }
                            icon={
                              <IconButton
                                sx={{
                                  border: "3px solid rgb(204, 210, 226)",
                                  borderRadius: "10%",
                                  padding: "2px",
                                }}
                              >
                                <ListIcon
                                  style={{
                                    color: location.pathname.includes(
                                      routeConstant.SELL
                                    )
                                      ? "#002e76"
                                      : "#ccd2e2",
                                  }}
                                />
                              </IconButton>
                            }
                            primary="Sell"
                          /> */}
                              {context.omsUserData?.UserRoles.includes(
                                "Admin" || "Agent"
                              ) && (
                                <SidebarMenuItem
                                  to={routeConstant.FCL}
                                  menuInnerItem={true}
                                  selected={
                                    location.pathname.includes(
                                      routeConstant.FCL
                                    )
                                      ? true
                                      : false
                                  }
                                  icon={
                                    <IconButton
                                      sx={{
                                        border: "3px solid rgb(204, 210, 226)",
                                        borderRadius: "10%",
                                        padding: "2px",
                                      }}
                                    >
                                      <ListIcon
                                        style={{
                                          color: location.pathname.includes(
                                            routeConstant.FCL
                                          )
                                            ? "#002e76"
                                            : "#ccd2e2",
                                        }}
                                      />
                                    </IconButton>
                                  }
                                  primary="Quote"
                                />
                              )}
                            </Collapse>
                          </>
                        )}
                      </>
                    ) : null}

                    {context.omsUserData?.UserRoles.includes(
                      "Admin" || "Agent"
                    ) || (
                      <>
                        {IsShowRMSLCL() && (
                          <SidebarMenuItem
                            to={routeConstant.LCL}
                            menuInnerItem={true}
                            selected={
                              location.pathname.includes(routeConstant.LCL)
                                ? true
                                : false
                            }
                            icon={
                              <IconButton
                                sx={{
                                  // border: "3px solid rgb(204, 210, 226)",
                                  // borderRadius: "10%",
                                  padding: "2px",
                                  // marginLeft: "20px",
                                }}
                              >
                                <Shipment
                                  style={{
                                    color: location.pathname.includes(
                                      routeConstant.LCL
                                    )
                                      ? "#002e76"
                                      : "#ccd2e2",
                                  }}
                                />
                              </IconButton>
                            }
                            primary="LCL"
                          />
                        )}
                        {IsShowRMSFCL() && (
                          <SidebarMenuItem
                            to={routeConstant.FCL}
                            menuInnerItem={true}
                            selected={
                              location.pathname.includes(routeConstant.FCL)
                                ? true
                                : false
                            }
                            icon={
                              <IconButton
                                sx={{
                                  // border: "3px solid rgb(204, 210, 226)",
                                  // borderRadius: "10%",
                                  padding: "2px",
                                  // marginLeft: "20px",
                                }}
                              >
                                <Shipment
                                  style={{
                                    color: location.pathname.includes(
                                      routeConstant.FCL
                                    )
                                      ? "#ccd2e2"
                                      : "#002e76",
                                  }}
                                />
                              </IconButton>
                            }
                            primary="FCL"
                          />
                        )}
                      </>
                    )}
                  </Collapse>
                </>
              ) : (
                IsShowRMS() && (
                  <SidebarMenuItem
                    to={routeConstant.RMS_SIGNUP}
                    selected={
                      location.pathname.includes(routeConstant.RMS_SIGNUP)
                        ? true
                        : false
                    }
                    icon={
                      <MoveToInboxIcon
                        colorCode={
                          location.pathname.includes(routeConstant.RMS_SIGNUP)
                            ? "#002e76"
                            : "#ccd2e2"
                        }
                      />
                    }
                    primary="RMS"
                  />
                )
              )}
            </>
          )}
        </List>
      </Drawer>
      <div
        className="asidecomp"
        style={{
          zIndex: theme.zIndex.drawer + 1,
          width: `calc(100% - 1px - 6rem)`,
          transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          ...(context.sidebarOpen && {
            width: `calc(100% - ${drawerWidth}rem - 1px)`,
            transition: theme.transitions.create(["width", "margin"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }),
        }}
      >
        {location.pathname.includes(routeConstant.SHIPMENT) ||
        location.pathname.includes(routeConstant.STATEMENT) ? null : (
          <Header
            sidebarHandle={() => context.setSidebarOpen((prev) => !prev)}
          />
        )}
        <Outlet />
      </div>
      <SwipeableDrawer
        anchor={"right"}
        className={"_notificationDrawer"}
        onBackdropClick={() => {
          if (context.notificationOpen.type !== "subOrder") {
            context.setNotificationOpen({
              open: false,
              type: "",
              reload: true,
            });
          }
        }}
        // variant="permanent"
        hideBackdrop={false}
        open={context.notificationOpen.open}
        // onClose={() =>
        //   context.setNotificationOpen({
        //     open: false,
        //     type: "",
        //   })
        // }
        // onOpen={() =>
        //   context.setNotificationOpen({
        //     open: true,
        //     type: "",
        //   })
        // }
      >
        {context.notificationOpen.type === "Notification" ? (
          <Notification />
        ) : context.notificationOpen.type === "subOrder" ? (
          <ViewSubOrder />
        ) : (
          <MergeOrder />
        )}
      </SwipeableDrawer>
    </div>
  );
}
